// /* document.addEventListener('DOMContentLoaded', function () {
//     var checkbox = document.querySelector('.es_subscribe');
//     var panel = document.querySelector('.es_secureSubscriptionPlan');
//     checkbox.addEventListener('change', function () {
//       if (this.checked) {
//         panel.style.maxHeight = panel.scrollHeight + 'px';
//       } else {
//         panel.style.maxHeight = '0';
//       }
//     });
//   }); */
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.product-actions__add-to-cart-button').forEach(function (button) {
//     button.addEventListener('click', function (e) {
//       e.preventDefault();
//       // Get quantity
//      // var quantityInput = document.querySelector('.input.input--primary.product-quantity__input');
//      // var quantity = quantityInput ? quantityInput.value : 1;

//       // Get selected radio button value (if any)
//       var selectedPlanInput = document.querySelector('.es_radio-image-group input[name="product_option"]:checked');
//       var selling_plan = selectedPlanInput ? selectedPlanInput.value : null;

//       // Get selected value from the dropdown
//       var selectedMain = document.querySelector('.product-selectors select');
//       var selectedOptionText = selectedMain.options[selectedMain.selectedIndex].text;

//       // Set variant ID based on selected option text
//       var selling_planMain;
//       if (selectedOptionText === "Annual") {
//         selling_planMain = 50520599888192;
//       } else {
//         selling_planMain = 50520599822656;
//       }

//       // Create cart items array
//       var items = [
//         {
//           id: selling_planMain,
//           quantity: 1,
//         },
//         {
//           id: 50517595717952,
//           quantity: 1,
//           selling_plan: selling_plan,
//         }
//       ];

//       // Send add-to-cart request
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({ items: items })
//       })
//       .then(response => {
//         if (response.ok) {
//           console.log('Items added to cart successfully.');
//           window.location.href = '/checkout';  // Uncomment to redirect
//         } else {
//           return response.json().then(err => {
//             console.error('Error:', err);
//           });
//         }
//       })
//       .catch(error => {
//         console.error('Fetch error:', error);
//       });
//     });
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const radioButtons = document.querySelectorAll('.es_radio-image-group input[name="product_option"]');
//   radioButtons.forEach(function (radio) {
//     radio.addEventListener('change', function () {
//       if (this.checked) {
//         const selectedValue = this.value;
//         const selector = document.querySelector('.product-selectors select');
//         if (!selector) return;
//         if (selectedValue === "693069152576") {
//           selector.value = "Monthly";
//         } else {
//           selector.value = "Annual";
//         }
//         // Optional: Manually trigger a change event if needed
//         const changeEvent = new Event('change', { bubbles: true });
//         selector.dispatchEvent(changeEvent);
//       }
//     });
//   });
// // });
// function initESAsellingPlan(){
//   document.querySelectorAll('input[data-radio-type="selling_plan"]').forEach(radio => {
//     radio.addEventListener('click', function(e) {
//         const sellingPlanId = this.dataset.sellingPlanId
//         const variantId = this.dataset.variantId;
//         const quantity = 1;
//         console.log("selectedVariantId",variantId,"sellingPlanId",sellingPlanId)
//         if (!sellingPlanId || !variantId) return;

//           document.querySelectorAll('.product-actions__add-to-cart-button').forEach(function (button) {
     
//         button.addEventListener('click', function (e) {
//           setTimeout(() => {
            
//                 const VsellingPlanId = document.querySelector(".selected-selling-plan-id").value
//                 const data = {
//                   id: 50517595717952,
//                 quantity: quantity,
//             selling_plan: VsellingPlanId
//           };
//             fetch('/cart/add.js', {
//               method: 'POST',
//               headers: {
//               'Content-Type': 'application/json',
//               'Accept': 'application/json'
//             },
//             body: JSON.stringify(data)
//             })
//           .then(response => response.json())
//           .then(cart => {
//             console.log('Added to cart:', cart);
//             // alert(`Added variant ${variantId} with selling plan ${VsellingPlanId} to cart!`);
//             }).catch(error => console.error('Add to cart failed:', error));
          
           
//           }, 1000);
      
//           });
//         });
//       });
// })
// }

// document.addEventListener("DOMContentLoaded", function () {
// initESAsellingPlan()
// });



class ESASellingPlan {
  constructor() {
    this.quantity = 1;
    this.init();
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      this.bindSellingPlanRadios();
      this.bindAddToCartButtons();
      this.initPriceObservers();
    });
  }

  bindSellingPlanRadios() {
    const radios = document.querySelectorAll('input[data-radio-type="selling_plan"]');

    radios.forEach(radio => {
      radio.addEventListener('click', (e) => {
        const sellingPlanId = radio.dataset.sellingPlanId;
        const variantId = radio.dataset.variantId;

        console.log("selectedVariantId", variantId, "sellingPlanId", sellingPlanId);

        if (!sellingPlanId || !variantId) return;

        // Store selected selling plan globally (or update hidden input)
        const input = document.querySelector(".selected-selling-plan-id");
        if (input) {
          input.value = sellingPlanId;
        }
      });
    });
  }

  bindAddToCartButtons() {
    const buttons = document.querySelectorAll('.product-actions__add-to-cart-button');
    const input = document.querySelector(".selected-selling-plan-id");
    if (!input) {
      return;
    }
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        button.disabled = true;
        button.classList.add('adding');
        button.querySelector('.js-product-add-to-cart-button-text').textContent = 'Adding to cart ...'
        const form = button.closest('form');
        
        if (form) {
          form.addEventListener('submit', (ev) => ev.preventDefault(), { once: true });
        }
        this.handleAddToCart(form, button);
      });
    });
  }

  handleAddToCart(form, btn) {
    const formData = new FormData(form);

    const mainVariantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    const sellingPlanId = document.querySelector(".selected-selling-plan-id")?.value || 693691908416;

    if (!mainVariantId) {
      console.warn("No main product variant found");
      return;
    }

    const items = [
      {
        id: mainVariantId,
        quantity: parseInt(quantity)
      },
      {
        id: 50517595717952,
        quantity: this.quantity,
        selling_plan: sellingPlanId
      }
    ];

    this.addMultipleItems(items, btn);
  }

  addMultipleItems(items, btn) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(res => res.json())
    .then(res => {
      console.log('Items added:', res);
      btn.disabled = false;
      btn.classList.remove('adding');
      btn.querySelector('.js-product-add-to-cart-button-text').textContent = 'Add to cart'
      window.location.href = '/cart'
      
    })
    .catch(err => {
      console.error('Add to cart failed:', err);
    });
  }

  initPriceObservers() {
    const updateAll = () => {

      const perUnitEl = document.querySelector(
        '.purchase-option .easy-purchase-option-details .esa_subscription_per_unit_delivery_span'
      );
      if (perUnitEl && perUnitEl.textContent !== '+ $38/mo') {
        perUnitEl.textContent = '+ $38/mo';
      }

      const yearlyTarget = document.querySelector('.subscription-options .esa_subscription_price_and_per_unit_delivery');

      if (yearlyTarget) {
        const fromTxt = yearlyTarget.querySelector('#esa-from-txt');
        const perUnit = yearlyTarget.querySelector('.esa_subscription_per_unit_delivery_span');

        if (fromTxt && fromTxt.textContent !== '$195.00 + $400') {
          fromTxt.textContent = '$195.00 + $400';
        }

        if (perUnit && perUnit.textContent !== '') {
          perUnit.textContent = '';
        }
      }

      const customTarget = document.querySelectorAll('.esa-upper-purchase-options')[1];

      if (customTarget) {
        const priceEl = customTarget.querySelector('.price');
        const compareEl = customTarget.querySelector('.compare-price');

        if (priceEl && priceEl.textContent !== '$595.00') {
          priceEl.textContent = '$595.00';
        }

        if (compareEl && compareEl.textContent !== '$651.00') {
          compareEl.textContent = '$651.00';
        }
      }
    };

    const init = () => {
      let timeout;

      const observer = new MutationObserver(() => {
        clearTimeout(timeout);
        timeout = setTimeout(updateAll, 50);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });

      // initial run
      updateAll();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
}

// Initialize class
new ESASellingPlan();